import { render, staticRenderFns } from "./SysUserActiveForm.vue?vue&type=template&id=87c18e0e&"
import script from "./SysUserActiveForm.vue?vue&type=script&lang=js&"
export * from "./SysUserActiveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports